module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "fmtitle"
  }, [_vm._v("CONTENT")])]), _c('h2', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_List_of_Maps"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of maps")])])]), _vm._v(" "), _c('h2', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Editor_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Series Editor’s Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Author_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 1")]), _vm._v(" Invasion")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 2")]), _vm._v(" A Desperate Situation")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Battle for Cassel")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 4")]), _vm._v(" Hondeghem")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 5")]), _vm._v(" Hazebrouck")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 6")]), _vm._v(" Let Battle Commence")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 7")]), _vm._v(" Breakout")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold conspace"
  }, [_vm._v("Chapter 8")]), _vm._v(" The Tours")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Car_Tour_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Car Tour 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Walk_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walk 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Walk_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walk 2")])]), _vm._v(" "), _c('h2', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Car_Tour_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Car Tour 2")])]), _vm._v(" "), _c('h2', {
    staticClass: "con_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic conspace1"
  }, [_vm._v("Appendix")]), _vm._v(" Notes on some of the individuals mentioned in the text")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0